import { render, staticRenderFns } from "./ContactOtherForm.vue?vue&type=template&id=2bcae07f&scoped=true"
import script from "./ContactOtherForm.vue?vue&type=script&lang=js"
export * from "./ContactOtherForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bcae07f",
  null
  
)

export default component.exports